import React from 'react';
import { IIconProps } from './utils';

export const Unlink = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 17" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.00016 8.49967L3.49602 9.00013C2.39043 10.1057 2.39043 11.8982 3.49602 13.0038C4.60161 14.1094 6.39412 14.1094 7.4997 13.0038L8.00016 12.4997M8.00016 4.49967L8.50062 3.99553C8.74881 3.74734 9.03162 3.55487 9.3335 3.41811M12.0002 8.49967L12.5043 7.99921C13.6099 6.89363 13.6099 5.10112 12.5043 3.99553C12.3486 3.83983 12.1793 3.70605 12.0002 3.59421M3.3335 3.83301L2.00016 2.49967M12.6668 13.1663L14.0002 14.4997M6.66683 3.16634V1.83301M2.66683 6.49967H1.3335M9.3335 15.1663V13.833M14.6668 9.83301H13.3335"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="1.33333"
    />
  </svg>
);
